import dayjs from 'dayjs'

import { UserPlan } from '../../types/fam-graphql'

export const reorderPlan = (plan?: UserPlan | null) => {
  if (plan && plan.menu) {
    const day = dayjs(plan.start_at).day()
    const days = [6, 0, 1, 2, 3, 4, 5]
    const startIndex = days[day]

    if (startIndex !== 0) {
      const initialArray = Array.from(plan.menu)
      const spliced = initialArray.splice(0, startIndex)
      const menu = initialArray.concat(spliced)
      return {
        ...plan,
        menu,
      }
    }
  }
  return plan
}
